/**
 * Logic for the trip-format template.
 * Specifically to handle rendering the unique trip-formats Hero
 */
;(function(jQuery, pa){
	"use strict";
	function ProjectsAbroadTripFormat()
	{
		var global = {
		}

		var fn = {
			init: function()
			{
				fn.setupGradientWidth();
            },

            setupGradientWidth: function() {
                if (jQuery('.Hero--trip-format').length) {
                    fn.doGradientWidth();

                    var rerunResize = pa.helper.debounce(fn.doGradientWidth, 300);
                    jQuery(window).resize(rerunResize);
                }
            },

            doGradientWidth: function() {
                var gradElem = jQuery('.Hero__trip-format-gradient-box');
                var overlayElem = jQuery('.Hero__trip-format-overlay');
                var vw = jQuery(window).width();
                gradElem.css({
                    'width': '',
                    'margin-left': ''
                }).removeClass('has-width-calculated');

                if (vw > 992) {
                    var offset = overlayElem.offset().left;
                    gradElem.css({
                        'width': (offset + 1),
                        'margin-left': -(offset + 1)
                    }).addClass('has-width-calculated');
                }
            }
		}

		jQuery(fn.init);
	}

	new ProjectsAbroadTripFormat();
}($, pa));
